'use strict';

function PasswordResetSent() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this._email_address = null;
  this._submitButton = null;
  this._resendAfterSeconds = 10;

  this.init = function () {
    this._email_address = Cookies.getJSON('reset_email_val');
    $('#email').text(this._email_address);
    $('#send_another_email').on('click', $.proxy(this._onResendActivationEmail, this));
  };

  this.initAllReady = function () {
    this._submitButton = $('.button', this.node).show();
  };

  this._setButtonLoadState = function (disabled) {
    if (disabled) {
      this._submitButton.mogo().setDisabledLoadState();
    } else {
      this._submitButton.mogo().removeDisabledLoadState();
    }
  };

  this._onResendActivationEmail = function () {
    this._setButtonLoadState(true);
    if (this._email_address) {
      var data = {
        email_address: this._email_address
      };
      var request = new APIRequest('/accounts/forgot_password', 'POST', data, $.proxy(this._onActivationEmailSent, this));
      request.send();
      this._toggleResend();
    }
  };

  this._toggleResend = function () {
    $('.resend-email').toggle();
    $('.email-sent').toggle();
  };

  this._onActivationEmailSent = function (data, response) {
    if (response == 200) {} else {
      $('#Notification').mogo().get();
    }
    setTimeout(this._toggleResend, this._resendAfterSeconds * 1000);
    this._setButtonLoadState(false);
  };
}